import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const WHATSAPP_URL = "https://wa.me/5547992561262?text=Olá!%20Gostaria%20de%20solicitar%20um%20orçamento.";

const NAV_LINKS = [
  { label: "Início", to: "/" },
  { label: "Sobre", to: "/sobre" },
  { label: "Serviços", to: "/servicos" },
  { label: "Portfólio", to: "/#portfolio" },
  { label: "Contato", to: "/#contato" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const isActive = (to: string) => {
    if (to.startsWith("/#")) return false;
    return location.pathname === to;
  };

  const handleHashLink = (e: React.MouseEvent<HTMLAnchorElement>, to: string) => {
    if (to.startsWith("/#")) {
      e.preventDefault();
      const id = to.replace("/#", "");
      if (location.pathname !== "/") {
        window.location.href = to;
        return;
      }
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
      setMenuOpen(false);
    } else {
      setMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white shadow-md" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-[88px]">
        {/* Logo */}
        <Link to="/" className="flex items-center cursor-pointer">
          <img
            src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/9dd974b3e895b7f64206723b1ef41387.png"
            alt="Construlife Engenharia e Arquitetura"
            className="h-[92px] w-auto object-contain p-[10px]"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-10">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              onClick={(e) => handleHashLink(e, link.to)}
              className={`text-[15px] font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                scrolled
                  ? isActive(link.to)
                    ? "text-[#2563EB]"
                    : "text-[#1F1F1F] hover:text-[#2563EB]"
                  : isActive(link.to)
                  ? "text-[#C9A24A]"
                  : "text-white hover:text-[#C9A24A]"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* CTA Button */}
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:flex items-center gap-2 bg-[#2563EB] hover:bg-[#1E3A8A] text-white text-[14px] font-semibold px-6 py-3 rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-whatsapp-line text-lg" />
          Falar no WhatsApp
        </a>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
            scrolled ? "text-[#1F1F1F]" : "text-white"
          }`}
          aria-label="Menu"
        >
          <i className={`text-2xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-[#E5E7EB] px-6 py-4 flex flex-col gap-4">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              onClick={(e) => handleHashLink(e, link.to)}
              className={`text-[15px] font-medium cursor-pointer ${
                isActive(link.to) ? "text-[#2563EB]" : "text-[#1F1F1F] hover:text-[#2563EB]"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-[#2563EB] text-white text-[14px] font-semibold px-5 py-3 rounded-lg cursor-pointer whitespace-nowrap w-fit"
          >
            <i className="ri-whatsapp-line text-lg" />
            Falar no WhatsApp
          </a>
        </div>
      )}
    </header>
  );
}
